
import React, { useEffect, useState } from 'react';

const ProcessingIndicator: React.FC = () => {
    const [dots, setDots] = useState<number>(0); // State to manage dots count for animation

    // Use an interval to update the dots
    useEffect(() => {
        const interval = setInterval(() => {
            setDots((prev) => (prev + 1) % 7); // Cycle through 0, 1, 2, 3,...,7 dots
        }, 500); // Update every 500ms

        // Cleanup the interval on unmount
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="col-md-12">
            <span>Processing{'.'.repeat(dots)}</span>
        </div>
    );
};

export default ProcessingIndicator;
